module.exports = __webpack_public_path__ + "img/maesteria.f79395cb.png";